import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAntrepoOutRequest } from '../models/request/antrepoOut/AddAntrepoOutRequest';
import { GetAntrepoOutListPagingAndFilterRequest } from '../models/request/antrepoOut/GetAntrepoOutListPagingAndFilterRequest';
import { CustomSingleSelectModel } from '../components/CustomSingleSelect';

export class AntrepoOutService {
    static async getAntrepoOutList(_selectedReceiverFirm: CustomSingleSelectModel | undefined) {
        try {
            var inputObj = {
                selectedReceiverFirm: _selectedReceiverFirm
            };

            console.log('SERVICE CALL - getAntrepoOutList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOut/getAntrepoOutList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAntrepoOutList(inputObj: GetAntrepoOutListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAntrepoOutList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOut/exportAntrepoOutList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoOutListPagingAndFilter(inputObj: GetAntrepoOutListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAntrepoOutListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOut/GetAntrepoOutListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addAntrepoOut(inputObj: AddAntrepoOutRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddAntrepoOut', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOut/AddAntrepoOut', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAntrepoOut(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAntrepoOut', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOut/deleteAntrepoOut', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoOutById(_id: string) {
        try {
            var inputObj = {
                id: _id,
            };

            console.log('SERVICE CALL - getAntrepoOutById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOut/getAntrepoOutById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoOutListByAntrepoInId(_antrepoInId: string | null) {
        try {
            var inputObj = {
                antrepoInId: _antrepoInId,
            };

            console.log('SERVICE CALL - GetAntrepoOutListByAntrepoInId', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOut/GetAntrepoOutListByAntrepoInId', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}